/**
 * Custom.js limpo — Seguro para Google Merchant
 * Versão limpa — Sem popups, sem scripts ocultos, sem manipulação suspeita.
 */

// ===== Scroll to Top (seguro) =====
if (window.matchMedia("(max-width: 768px)").matches) {
  window.onscroll = function() {
    var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
        btn = document.getElementById('scrollToTop');
    if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
  }
}

// ===== Cálculo de Parcelamento (seguro) =====
function parcelamento() {
  var preco = $('.product-form__info-item .price--highlight')
    .text()
    .replace('R$', '')
    .replace('.', '')
    .replace(',', '.')
    .trim();

  preco = parseFloat(preco);

  if (isNaN(preco)) return;

  // cálculo seguro
  var calculo = ((preco * 1.1979) / 12).toFixed(2).replace('.', ',');

  $('.parcelamento').html('<span>em até 12x de <b>R$ ' + calculo + '</b></span>');
}

$(".block-swatch__radio").change(function () {
  setTimeout(parcelamento, 150);
});

// ===== Card de produto clicável (seguro) =====
document.addEventListener('click', function(event) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }

  var ignoredSelector = 'a, button, input, select, textarea, label, form, [data-action], [data-secondary-action]';

  if (event.target.closest(ignoredSelector)) {
    return;
  }

  var productItem = event.target.closest('.product-item');

  if (!productItem) {
    return;
  }

  var productLink = productItem.querySelector('.product-item__image-wrapper[href], .product-item__title[href]');

  if (productLink && productLink.href) {
    window.location.href = productLink.href;
  }
});

// ===== Fim do custom.js =====
